export const DEFAULT_CLASS_TRANSFORM_OPTIONS = {
  strategy: 'excludeAll'
};
export const __dynamicControlOptions__ = '__dynamicControlOptions__';
export const ValidationKeys = {
  nested: {
    type: 'nestedValidation',
    typeKey: 'NESTED_VALIDATION'
  },
  conditional: {
    type: 'conditionalValidation'
  },
  custom: {
    type: 'customValidation',
    typeKey: 'CUSTOM_VALIDATION'
  }
};